import React, { useState } from "react";
import { Button } from "./ui";
import "./GoogleLoginButton.css";

/**
 * Кнопка «Войти через Google» — теперь ЗАГЛУШКА, а не вход.
 *
 * Почему. Вход через Google в России недоступен по требованиям
 * законодательства. Раньше кнопка вела на accounts.google.com; сейчас она
 * открывает объяснение — что произошло и что делать тем, кто входил
 * через Google раньше.
 *
 * Почему кнопку не убрали совсем. У части людей это был ЕДИНСТВЕННЫЙ
 * способ входа: пароля они не заводили. Убери кнопку — человек увидит
 * форму, которой не может воспользоваться, и решит, что аккаунт пропал.
 * Кнопка на привычном месте с понятным текстом отвечает на вопрос,
 * который у него возникнет.
 */
export default function GoogleLoginButton({ disabled, label }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="rb-google">
      <button
        type="button"
        className="rb-google__btn"
        onClick={() => setOpen(true)}
        disabled={disabled}
      >
        {/* Официальный логотип Google. Не эмодзи и не PNG. */}
        <svg width="20" height="20" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C12.955 4 4 12.955 4 24s8.955 20 20 20s20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/>
          <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4C16.318 4 9.656 8.337 6.306 14.691z"/>
          <path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0 1 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/>
          <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/>
        </svg>
        {label || "Войти через Google"}
      </button>

      {open && (
        <div
          className="rb-google__overlay"
          onClick={() => setOpen(false)}
          role="dialog"
          aria-modal="true"
          aria-label="Вход через Google недоступен"
        >
          <div className="rb-google__modal" onClick={(e) => e.stopPropagation()}>
            <h3 className="rb-google__title">Вход через Google больше не работает</h3>

            <p className="rb-google__text">
              По требованиям российского законодательства вход через Google
              на нашем сайте недоступен. Аккаунт при этом никуда не делся —
              все игры, алмазы и прогресс на месте.
            </p>

            <div className="rb-google__how">
              <div className="rb-google__how-title">Если раньше ты входил через Google</div>
              <ol className="rb-google__steps">
                <li>
                  Войди через <b>Яндекс</b> — если почта в Яндексе та же самая,
                  ты попадёшь в свой аккаунт.
                </li>
                <li>
                  Не получилось? Напиши в поддержку — восстановим доступ
                  вручную и поможем поставить пароль.
                </li>
              </ol>
            </div>

            <div className="rb-google__actions">
              <Button
                variant="ghost"
                onClick={() => {
                  setOpen(false);
                  window.location.assign("/support");
                }}
              >
                Написать в поддержку
              </Button>
              <Button variant="primary" onClick={() => setOpen(false)}>
                Понятно
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
